import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { LinkComponent } from '../../../LinkComponent';

interface Props {
	siteName: string;
}

export const SuccessModal: FC<Props> = (props) => {
	const { siteName } = props;

	return (
		<div>
			<FontAwesomeIcon icon={faCircleCheck} width={36} className="h-36px mx-auto d-block my-7 text-danger"/>
			<div className="text-center fw-bolder text-danger fs-6 mb-5">SenseJS was found!</div>
				<div className="text-center fs-6">
					Congratulations, you have correctly installed Flex on
				</div>
			<div className="text-center mb-3">{siteName}</div>
			<div className="text-center fs-8">
				You can now send
				<LinkComponent text='api calls with /evaluate' link='mailto:support@flex-charge.com' additionalClass="mx-1"/>
				to get transactions rescued.
			</div>
		</div>
	);
};
